import { Head, Link } from "@inertiajs/react"
import { ChevronLeft } from "lucide-react"
import { AdminShell } from "@/components/AdminShell"
import { PostForm, type PostFormData } from "@/components/admin/PostForm"

export default function AdminPostNew({ post }: { post: PostFormData }) {
  return (
    <>
      <Head title="New post">
        <meta name="description" content="Create a new blog post." />
        <meta property="og:title" content="New post" />
        <meta property="og:description" content="Create a new blog post." />
      </Head>
      <AdminShell>
        <Link
          href="/admin/posts"
          className="inline-flex items-center gap-1 text-sm text-ink-muted no-underline hover:text-ink-display"
        >
          <ChevronLeft className="h-4 w-4" />
          All posts
        </Link>
        <div className="mt-4 border-b border-hairline pb-6">
          <h1>New post</h1>
        </div>
        <PostForm initial={post} />
      </AdminShell>
    </>
  )
}
